import Markdown from 'react-markdown';

import { Cms } from '@bytel/product-wall';
import { DirectionEnum, FlexBox, GapSize, IconName } from '@bytel/trilogy-react';

import type { MobilePlanType } from '@app-types/plan';

import { Pepite } from './pepite';

function boldFirstWords(text: string, count: number): string {
    const words = text.split(' ');
    return `<b>${words.slice(0, count).join(' ')}</b> ${words.slice(count).join(' ')}`;
}

function boldTargettedWords(inputText: string, targetWords: string[]): string {
    const pattern = targetWords.map((word) => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');
    return inputText.replaceAll(new RegExp(`(${pattern})`, 'gi'), '<b>$1</b>');
}

interface OfferCardPepitesProps {
    offer: MobilePlanType;
}

export function OfferCardPepites({ offer }: Readonly<OfferCardPepitesProps>) {
    const splittedFromAbroad = offer.fromAbroad?.trim().split('\n');
    const dataFranceEurope = splittedFromAbroad?.[0] ? boldFirstWords(splittedFromAbroad[0], 2) : '';
    const internationalData = splittedFromAbroad?.[1]?.includes('autres destinations')
        ? boldFirstWords(splittedFromAbroad[1], 2)
        : '';
    let callsSms = '';
    if (offer.unlimitedCalls?.trim()) {
        callsSms = boldFirstWords(
            boldTargettedWords(offer.unlimitedCalls, ["2h d'appels et SMS illimités", 'Appels, SMS, MMS illimités']),
            4,
        );
    }
    const internationalCalls = offer.internationalCall?.trim() ? boldFirstWords(offer.internationalCall, 5) : '';
    const bTv = offer.wordingBtv?.trim() ? boldFirstWords(offer.wordingBtv, 5) : '';
    const twinSim = offer.hasDoubleSim ? boldFirstWords('Multi-SIM incluse utilisable sur un second appareil', 2) : '';

    const pepites = [
        { content: dataFranceEurope, iconName: IconName.AT },
        { content: internationalData, iconName: IconName.AIR_TRAVEL },
        { content: callsSms, iconName: IconName.MOBILE_GLOBE },
        { content: internationalCalls, iconName: IconName.PHONE_GLOBE },
        { content: bTv, iconName: IconName.BTV },
        { content: twinSim, iconName: IconName.SIM_CARDS },
    ].filter(({ content }) => content);

    return (
        <FlexBox
            direction={DirectionEnum.COLUMN}
            gap={{
                desktop: GapSize.FOUR,
                mobile: GapSize.TWO,
            }}
            data-cy='offer-card-pepites'
        >
            {pepites.map(({ content, iconName }) => (
                <Pepite key={iconName} iconName={iconName}>
                    <Cms content={content} />
                </Pepite>
            ))}

            {offer.cmsContent?.addedPepites?.map((pepite) => (
                <Pepite key={pepite.pepite} iconName={pepite.icon}>
                    <Markdown>{pepite.pepite}</Markdown>
                </Pepite>
            ))}
        </FlexBox>
    );
}
